function getFireCoreCost(state, props) {
	return state.fireCoreCount === props.targetFireCoreCount ? 0 : 1e6;
}
export { getFireCoreCost };

//# sourceMappingURL=index144.js.map